<template>
  <v-layout align-center>
    <v-dialog
      width="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="importDocumentsDialogOpened"
      persistent
      @keydown.esc="importDocumentsDialogOpened = false"
    >
      <v-card flat @drop.prevent="addFile" @dragover.prevent>
        <v-card-title class="title">
          {{ $t('inbox.attachDocument') }}
        </v-card-title>
        <v-divider />
        <v-alert
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left mb-4"
          :class="$vuetify.breakpoint.smAndUp ? 'mx-4' : 'mx-2'"
        >
          {{ $t('alerts.dragAndDropFiles') }}
        </v-alert>
        <v-card-text class="mb-1 mt-1">
          <v-layout column>
            <v-flex class="text-xs-left mb-2 font-weight-bold">
              <v-layout align-center>
                <div class="py-3">{{ $t('documents.selectedDocuments') }}:</div>
                <v-spacer />
                <v-progress-circular
                  v-if="documentImporting"
                  indeterminate
                  size="25"
                  class="primary--text mr-2"
                />
                <v-btn
                  outline
                  class="default-input text-capitalize primary--text"
                  :disabled="documentImporting"
                  @click="pickDocuments"
                >
                  <v-layout align-center>
                    <v-icon class="mr-2" size="20">add</v-icon>
                    {{ $t('documents.selectFiles') }}
                  </v-layout>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex class="text-xs-left mb-4" v-if="isEmpty(documentsToImport)">
              {{ $t('documents.noDocumentsSelected') }}
            </v-flex>
            <v-flex class="mb-4" v-else>
              <v-layout
                align-center
                :key="i"
                v-for="(doc, i) in documentsToImport"
              >
                <v-icon color="primary"> insert_drive_file </v-icon>
                <span class="ml-1 my-1">{{ doc.name }}</span>
                <v-spacer />
                <v-icon
                  @click="documentsToImport.splice(i, 1)"
                  style="cursor: pointer"
                  color="error"
                  >cancel</v-icon
                >
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-capitalize primary"
            @click="importDocuments()"
            :disabled="documentImporting || isEmpty(documentsToImport)"
          >
            {{ $t('documents.uploadAll') }}
          </v-btn>
          <v-btn
            class="text-capitalize primary--text"
            outline
            @click="
              importDocumentsDialogOpened = false;
              documentsToImport = [];
            "
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <quill-editor
      v-model="newMessage"
      :options="editorOption"
      :disabled="sending"
      class="message-input default-input"
    />
    <v-dialog
      width="600"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="scheduledTimeDialogOpened"
      persistent
      @keydown.esc="scheduledTimeDialogOpened = false"
    >
      <v-card flat>
        <v-card-title class="title pb-1"> Schedule message </v-card-title>
        <v-card-title class="subheading pt-0">
          {{ timeZone }}
        </v-card-title>
        <v-card-text class="mb-1 mt-1">
          <date-picker
            v-model="scheduledTime"
            type="datetime"
            :showSecond="false"
            inline
            use12h
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-capitalize primary"
            @click="sendMessage"
            :disabled="!scheduledTime"
            :loading="sending"
          >
            Schedule Message
          </v-btn>
          <v-btn
            class="text-capitalize primary--text"
            outline
            @click="
              scheduledTimeDialogOpened = false;
              scheduledTime = null;
            "
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-flex shrink>
      <v-layout column class="ml-2" align-center>
        <v-tooltip top v-if="!isAdvisor && messageTagsEnabled">
          <v-radio-group
            v-model="messageTag"
            class="my-0 py-0"
            slot="activator"
            hide-details
          >
            <v-radio label="Not Urgent" value="general" class="my-0" />
            <v-radio label="Urgent" value="urgent" class="my-0" />
            <v-radio label="Emergency" value="emergency" class="my-0" />
          </v-radio-group>
          <span>Please tag the message accordingly</span>
        </v-tooltip>

        <v-layout
          align-center
          :column="
            $vuetify.breakpoint.xsOnly && !isAdvisor && !messageTagsEnabled
          "
        >
          <v-tooltip
            bottom
            :class="
              $vuetify.breakpoint.xsOnly && !isAdvisor && messageTagsEnabled
                ? 'mb-2'
                : ''
            "
            v-if="conversationCompanies"
          >
            <v-icon
              slot="activator"
              style="cursor: pointer"
              class="mx-2"
              size="30"
              @click="
                openImportDocumentsDialog();
                selectedCompanyId = conversationCompanies[0].id;
              "
              v-if="conversationCompanies.length === 1"
            >
              attach_file
            </v-icon>
            <v-menu
              transition="slide-y-transition"
              bottom
              left
              class="my-1"
              v-else
              slot="activator"
            >
              <v-icon
                slot="activator"
                style="cursor: pointer"
                class="mx-2"
                size="30"
              >
                attach_file
              </v-icon>
              <v-list>
                <div
                  class="grey--text text--darken-1 caption px-3"
                  style="height: 20px"
                >
                  Attach Document for Which Entity?
                </div>
                <v-list-tile
                  :key="i"
                  v-for="(company, i) in conversationCompanies"
                  @click="
                    selectedCompanyId = company.id;
                    openImportDocumentsDialog();
                  "
                >
                  <v-list-tile-title>
                    {{ company.name }} ({{ company.entity_type }})
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <span class="caption" v-if="conversationCompanies.length === 1">{{
              $t('inbox.attachFileFor', {
                name: this.conversationCompanies[0].name,
              })
            }}</span>
            <span class="caption" v-else>{{ $t('inbox.attachFile') }}</span>
            <input
              type="file"
              style="display: none"
              ref="selectedDocuments"
              multiple
              @change="onDocumentsPicked"
            />
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              class="primary text-none"
              style="border-radius: 50px"
              @click="sendMessage()"
              :disabled="!newMessage"
              :loading="sending"
              fab
              flat
              small
            >
              <v-icon class="white--text"> send </v-icon>
            </v-btn>
            <span>{{ $t('inbox.sendMessage') }}</span>
          </v-tooltip>
        </v-layout>
        <v-tooltip bottom left v-if="isAdvisor">
          <v-checkbox
            v-model="remindClient"
            label="Auto-remind?"
            class="mx-2 mt-1 pb-0"
            hide-details
            slot="activator"
          />
          <span
            >Client will receive a reminder every 3 days for a month if not they
            do not reply. Any new message will remove the reminder.</span
          >
        </v-tooltip>
        <v-tooltip bottom v-if="isAdvisor">
          <v-btn
            slot="activator"
            @click="openScheduleDialog()"
            class="text-none"
            :disabled="!newMessage || sending"
            flat
            small
          >
            Schedule
          </v-btn>
          <span>Schedule for later</span>
        </v-tooltip>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import API from '@/api';
import isEmpty from 'lodash/isEmpty';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import FirmPreferenceMixins from '../mixins/FirmPreferenceMixins';

export default {
  props: {
    conversationCompanies: {
      type: Array,
    },

    selectedConversationId: {
      type: Number,
    },
  },

  components: {
    DatePicker,
  },

  mixins: [FirmPreferenceMixins],

  data() {
    return {
      newMessage: '',
      scheduledTime: null,
      messageTag: 'general',
      remindClient: false,
      selectedCompanyId: null,
      sending: false,
      scheduledTimeDialogOpened: false,

      importDocumentsDialogOpened: false,
      documentsToImport: [],
      documentImporting: false,

      editorOption: {
        formats: ['bold', 'italic', 'underline', 'link', 'indent', 'list'],
        modules: {
          toolbar:
            window.innerWidth >= 768
              ? [
                  ['bold', 'italic', 'underline'],
                  [{ indent: '-1' }, { indent: '+1' }],
                  ['link'],
                  [{ list: 'ordered' }, { list: 'bullet' }],
                ]
              : [['bold', 'italic', 'underline']],
        },
        placeholder: this.$t('inbox.message'),
        bounds: '.message-input',
      },
    };
  },

  computed: {
    ...mapGetters(['isAdvisor']),
    timeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
  },

  methods: {
    isEmpty,
    openScheduleDialog() {
      this.scheduledTimeDialogOpened = true;
    },
    async sendMessage() {
      if (this.newMessage && !this.sending) {
        this.sending = true;
        const response = await API.conversation.sendMessage({
          text: this.newMessage
            .trim()
            .split('\n')
            .join('<br/>'),
          conversationId: this.selectedConversationId,
          hasReminder: this.remindClient,
          messageTag: this.messageTag,
          scheduledTime: this.scheduledTime
            ? moment(this.scheduledTime)
                .utc()
                .toISOString()
            : null,
        });

        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem.',
          });
          console.log(response.data.error);
        } else {
          this.$emit('messageSent');
          this.sending = false;
          this.newMessage = '';
          this.scheduledTimeDialogOpened = false;
          this.scheduledTime = null;
        }
      }
    },

    async onDocumentsPicked(e) {
      this.documentImporting = true;
      const documents = e.target.files;

      if (documents) {
        this.documentsToImport.push(...documents);
      }

      this.documentImporting = false;
    },

    async openImportDocumentsDialog() {
      this.documentsToImport = [];
      this.documentImporting = false;
      this.importDocumentsDialogOpened = true;
    },

    async importDocuments() {
      this.sending = true;
      this.importDocumentsDialogOpened = false;
      let path = '';
      try {
        for (const documentToImport of this.documentsToImport) {
          const companyId = this.selectedCompanyId
            ? this.selectedCompanyId
            : this.conversationCompanies[0].id;

          if (
            this.selectedCompanyId &&
            !this.conversationCompanies
              .map(c => c.id)
              .includes(parseInt(this.selectedCompanyId))
          ) {
            console.error('selectedCompanyId cannot be found in conversations');
            return this.$store.dispatch('application/setErrorNotification', {
              message: 'Something went wrong but we have been notified',
            });
          }

          const {
            data: { id, upload_link },
          } = await API.integration.getTemporaryUploadLink({
            companyId,
          });

          await API.integration.uploadToDropbox(upload_link, documentToImport);

          const response = await API.integration.processDocument({
            id,
            documentName: documentToImport.name,
            companyId,
            path: '/Attachments',
            conversationId: this.selectedConversationId,
          });

          if (response.data.error) {
            console.log(response.data.error);
          } else if (isEmpty(path)) {
            path = response.data.document_location;
          } else {
            path += '&!&'.concat(`${response.data.document_location}`);
          }
        }
        this.$store.dispatch('application/setSuccessNotification', {
          message: `You have successfully uploaded ${
            this.documentsToImport.length
          } document${this.documentsToImport.length > 1 ? 's' : ''}!`,
        });
        const response2 = await API.conversation.sendMessage({
          text: `$$attached$$${path}`,
          conversationId: this.selectedConversationId,
        });
        if (response2.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem.',
          });
          console.log(response2.data.error);
        } else {
          this.$emit('messageSent');
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Attachment unsuccessful. Please try again.',
        });
      } finally {
        this.sending = false;
        this.documentsToImport = [];
      }
    },

    pickDocuments() {
      const input = this.$refs.selectedDocuments;
      input.type = 'text';
      input.type = 'file';
      this.$refs.selectedDocuments.click();
    },

    async addFile(e) {
      this.importDocumentsDialogOpened = true;
      this.documentImporting = true;
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;

      this.documentsToImport.push(...droppedFiles);
      this.documentImporting = false;
    },

    removeFile(file) {
      this.files = this.files.filter(f => {
        return f != file;
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
.message-input {
  flex: auto;
  margin-left: 15px;
  background-color: #f1eded;
  border-radius: 10px;

  & >>> .ql-toolbar.ql-snow {
    border: none;
    border-bottom: 1px solid #ccc;
    text-align: start;
  }

  & >>> .ql-container.ql-snow {
    border: none;
    font-size: 14px;
  }

  & >>> .ql-container .ql-editor {
    min-height: 80px;
    max-height: 50vh;
    resize: vertical;
    overflow-wrap: break-word;
    max-width: 1053px;
  }

  & >>> .ql-formats button {
    height: 28px;
    width: 32px;
  }
}
</style>
